<body class="padding">
  <div id="upload_ecms">
    <ng-container *ngIf="!failFlag; then noError; else isError"></ng-container>
  </div>
</body>

<ng-template #noError>
  <ng-container *ngIf="!isUploading; then isUpload; else isSpinner"></ng-container>
</ng-template>

<ng-template #isError>
  <h2>Error uploading file!</h2>
  <span class="hubid">Please contact support</span>
</ng-template>

<ng-template #isUpload>
  <div class="editrow">
    <br />
    <div class="field-header">MPRN Number</div>
    <br />
    <mat-form-field>
      <input placeholder="MPRN" matInput [(ngModel)]="newECMS.mprn" />
    </mat-form-field>
    <br />
    <div class="panel">
      <button mat-raised-button color="primary" id="remove_ecms" (click)="remove()"
        [disabled]="isDisabled">Remove</button>
    </div>
    <div class="panel">
      <button mat-raised-button color="primary" id="cancel_ecms" (click)="cancel()"
        [disabled]="isDisabled">Cancel</button>
    </div>
  </div>
</ng-template>

<ng-template #isSpinner>
  <div class="uploader-status">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
